<!--
 Name: NeotivTrialsResources.vue
 Description: View to display the neotivTrials resources page.
 Created by: Andjelka Popovic on 2025-10-01
 Last edited by: Andjelka Popovic on 2026-01-23
-->
<template>
  <v-container fluid class="pa-0 full-width">

    <!-- hero graphic -->
    <div :style="{ backgroundColor: '#57509C', height: '750px' }" class="d-flex align-center">
      <v-row no-gutters class="d-flex align-center">
        <!-- hero text -->
        <v-col cols="11" md="5" class="pl-12">
          <p class="hero-title text-white">
            neotivTrials Resource Center
          </p>
          <p class="hero-text text-white mt-12">
            Here you can find support materials for using the neotivTrials app in your research studies.
          </p>
          <v-btn
            variant="flat"
            size="x-large"
            @click="scrollToSection('.manuals')"
            class="hero-text mt-12 mr-4"
          >
            User Manuals
          </v-btn>
          <v-btn
            variant="flat"
            size="x-large"
            @click="scrollToSection('.videos')"
            class="hero-text mt-12 mr-4"
          >
            Demo Videos
          </v-btn>
          <v-btn
            variant="flat"
            size="x-large"
            @click="scrollToSection('.studySupport')"
            class="hero-text mt-12"
          >
            Study Support Materials
          </v-btn>
        </v-col>
        <!-- v-col in required to make it work on the smaller devices in safari -->
        <!-- hidden-sm-and-down doesn't work with d-flex -->
        <v-col
          v-if="$vuetify.display.mdAndUp"
          cols="6"
          class="justify-end d-flex"
        >
          <v-img
            :src="require('@/assets/images/delcode2/delcode2_herosection_en.png')" cover height="550px"
          />
        </v-col>
      </v-row>
    </div>

    <!-- NeotivTrials demo videos-->

    <section>
      <v-container>
        <h2 class="text-left my-6">
          neotivTrials demo videos
          <v-divider></v-divider>
        </h2>
        <v-row>
          <v-col cols="12" md="6">
            <h4 class="text-center mb-0 mt-4">
              <span>First steps in the neotivPortal</span>
            </h4>
            <div class="video-wrapper" @click="openVideo(downloadTrialsEn)">
              <video
                class="inline-video"
                :src="downloadTrialsEn"
                muted
                playsinline
                :poster="require('@/assets/videos/en/nTrialsPosterEn.jpeg')"
              ></video>
            </div>

          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- Study Infos -->
    <section class="manuals anchor-section bg-white">
      <v-container>
        <h2 class="text-left my-6">
          neotivTrials User Manual
          <v-divider></v-divider>
        </h2>
        <p class="mb-4">Download the neotivTrials user manual in your preferred language. The manual is intended for
          study participants and can be handed out during onboarding at the beginning of the study.</p>
        <v-row>
          <v-col cols="12" sm="6">
            <ul class="trials-list mb-6">
              <li>
                <span class="d-flex flex-row align-items-center">
                  <v-img
                    :src="require('@/assets/images/flags/gb.svg')" width="30px" class="mr-4"
                  />
                  English
                </span>
                <v-btn
                  elevation="0">
                  <a href="/static/pdfs/manuals/neotivTrials_UserManual_EN.pdf"
                     target="_blank">
                    Download
                  </a>
                </v-btn>
              </li>
              <li>
                   <span class="d-flex flex-row align-items-center">
                  <v-img
                    :src="require('@/assets/images/flags/de.svg')" width="30px" class="mr-4"
                  />
                  German
                </span>
                <v-btn
                  elevation="0">
                  <a href="/static/pdfs/manuals/neotivTrials_UserManual_DE.pdf"
                     target="_blank">
                    Download
                  </a>
                </v-btn>
              </li>
              <li>
                   <span class="d-flex flex-row align-items-center">
                  <v-img
                    :src="require('@/assets/images/flags/it.svg')" width="30px" class="mr-4"
                  />
                  Italian
                </span>
                <v-btn
                  elevation="0">
                  <a href="/static/pdfs/manuals/neotivTrials_UserManual_ITA.pdf"
                     target="_blank">
                    Download
                  </a>
                </v-btn>
              </li>
              <li>
                <span class="d-flex flex-row align-items-center">
                  <v-img
                    :src="require('@/assets/images/flags/nl.svg')" width="30px" class="mr-4"
                  />
                  Dutch
                </span>
                <v-btn
                  elevation="0">
                  <a href="/static/pdfs/manuals/neotivTrials_UserManual_NL.pdf"
                     target="_blank">
                    Download
                  </a>
                </v-btn>
              </li>
              <li>
                 <span class="d-flex flex-row align-items-center">
                  <v-img
                    :src="require('@/assets/images/flags/ro.svg')" width="30px" class="mr-4"
                  />
                  Romanian
                </span>
                <v-btn
                  elevation="0">
                  <a href="/static/pdfs/manuals/neotivTrials_UserManual_RO.pdf"
                     target="_blank">
                    Download
                  </a>
                </v-btn>
              </li>

            </ul>
          </v-col>
          <v-col cols="12" sm="6">
            <ul class="trials-list">
              <li>
                 <span class="d-flex flex-row align-items-center">
                  <v-img
                    :src="require('@/assets/images/flags/es.svg')" width="30px" class="mr-4"
                  />
                  Spanish
                </span>
                <v-btn
                  elevation="0">
                  <a href="/static/pdfs/manuals/neotivTrials_UserManual_ES.pdf"
                     target="_blank">
                    Download
                  </a>
                </v-btn>
              </li>
              <li>
                 <span class="d-flex flex-row align-items-center">
                  <v-img
                    :src="require('@/assets/images/flags/us.svg')" width="30px" class="mr-4"
                  />
                  Spanish (US)
                </span>
                <v-btn
                  elevation="0">
                  <a href="/static/pdfs/manuals/neotivTrials_UserManual_ES_US.pdf"
                     target="_blank">
                    Download
                  </a>
                </v-btn>
              </li>
              <li>
                 <span class="d-flex flex-row align-items-center">
                  <v-img
                    :src="require('@/assets/images/flags/fi.svg')" width="30px" class="mr-4"
                  />
                  Finnish
                </span>
                <v-btn
                  elevation="0">
                  <a href="/static/pdfs/manuals/neotivTrials_UserManual_FN.pdf"
                     target="_blank">
                    Download
                  </a>
                </v-btn>
              </li>
              <li>
                <span class="d-flex flex-row align-items-center">
                  <v-img
                    :src="require('@/assets/images/flags/se.svg')" width="30px" class="mr-4"
                  />
                  Swedish
                </span>
                <v-btn
                  elevation="0">
                  <a href="/static/pdfs/manuals/neotivTrials_UserManual_SV.pdf"
                     target="_blank">
                    Download
                  </a>
                </v-btn>
              </li>
              <li>
                <span class="d-flex flex-row align-items-center">
                  <v-img
                    :src="require('@/assets/images/flags/fr.svg')" width="30px" class="mr-4"
                  />
                  French
                </span>
                <v-btn
                  elevation="0">
                  <a href="/static/pdfs/manuals/neotivTrials_UserManual_FR.pdf"
                     target="_blank">
                    Download
                  </a>
                </v-btn>
              </li>

            </ul>
          </v-col>
        </v-row>
      </v-container>
    </section>


    <!-- Videos -->
    <section class="videos anchor-section violet_light">
      <v-container>
        <h2 class="text-left my-6">
          Step-By-Step Instructions
          <v-divider></v-divider>
        </h2>
        <p class="mb-4"> The following videos provide step-by-step guidance on how to install the <b>neotivTrials
          app</b> on a smartphone or tablet, how to log in to a study, how to report a bug or issue within the app.
        </p>
        <p class="mb-4"> The videos are intended for study staff and study participants, and can be used or shown during
          the onboarding process. </p>
        <p class="mb-10"><b>Note:</b> To install the app, your device must have at least <b>Android 9.0 or iOS 15.0</b>
          as its
          operating system. If you are unsure, you can check which version you are using in your <b>device settings</b>.
        </p>

        <h2 class="mb-4">
          Video Instructions in English
          <v-divider></v-divider>
        </h2>
        <v-row no-gutters class="video-list mb-10">
          <!-- Left Column -->
          <v-col cols="12" sm="6" md="3">
            <h4 class="text-center my-6">
              <span>App installation for Android -</span>
              <span class="app-icon google">Google Play Store </span>
            </h4>
            <div class="video-wrapper" @click="openVideo(downloadAndroidVideoEn)">
              <video
                class="inline-video"
                :src="downloadAndroidVideoEn"
                muted
                playsinline
              ></video>
            </div>
          </v-col>

          <!-- Right Column -->
          <v-col cols="12" sm="6" md="3">
            <h4 class="text-center my-6">
              <span>App installation for iPhones & iPads - </span>
              <span class="app-icon apple">Apple App Store</span>
            </h4>
            <div class="video-wrapper" @click="openVideo(downloadAppleVideoEn)">
              <video
                class="inline-video"
                :src="downloadAppleVideoEn"
                muted
                playsinline
              ></video>
            </div>
          </v-col>
          <!-- Left Column -->
          <v-col cols="12" sm="6" md="3">
            <h4 class="text-center my-6">Start the app</h4>
            <div class="video-wrapper" @click="openVideo(appStartVideoEn)">
              <video
                class="inline-video"
                :src="appStartVideoEn"
                muted
                playsinline
              ></video>
            </div>
          </v-col>

          <!-- Right Column -->
          <v-col cols="12" sm="6" md="3">
            <h4 class="text-center my-6">Report a problem</h4>
            <div class="video-wrapper" @click="openVideo(bugReportVideoEn)">
              <video
                class="inline-video"
                :src="bugReportVideoEn"
                muted
                playsinline
              ></video>
            </div>
          </v-col>
        </v-row>

        <h2 class="mb-4">
          Video Instructions in German
          <v-divider></v-divider>
        </h2>
        <v-row no-gutters class="video-list mb-10">
          <!-- Left Column -->
          <v-col cols="12" sm="6" md="3">
            <h4 class="text-center my-6">
              <span>App-Installation für Android -</span>
              <span class="app-icon google">Google Play Store </span>
            </h4>
            <div class="video-wrapper" @click="openVideo(downloadAndroidVideo)">
              <video
                class="inline-video"
                :src="downloadAndroidVideo"
                muted
                playsinline
              ></video>
            </div>
          </v-col>

          <!-- Right Column -->
          <v-col cols="12" sm="6" md="3">
            <h4 class="text-center my-6">
              <span>App-Installation für iPhones und iPads - </span>
              <span class="app-icon apple">Apple App Store</span>
            </h4>
            <div class="video-wrapper" @click="openVideo(downloadAppleVideo)">
              <video
                class="inline-video"
                :src="downloadAppleVideo"
                muted
                playsinline
              ></video>
            </div>
          </v-col>
          <!-- Left Column -->
          <v-col cols="12" sm="6" md="3">
            <h4 class="text-center my-6">App starten</h4>
            <div class="video-wrapper" @click="openVideo(appStartVideo)">
              <video
                class="inline-video"
                :src="appStartVideo"
                muted
                playsinline
              ></video>
            </div>
          </v-col>

          <!-- Right Column -->
          <v-col cols="12" sm="6" md="3">
            <h4 class="text-center my-6">Ein Problem melden</h4>
            <div class="video-wrapper" @click="openVideo(bugReportVideo)">
              <video
                class="inline-video"
                :src="bugReportVideo"
                muted
                playsinline
              ></video>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- Support materials -->
    <section class="support bg-white studySupport anchor-section">
      <v-container>
        <h2 class="text-left my-6">
          Study Support
          <v-divider></v-divider>
        </h2>
        <p class="mb-4">Here you find additional materials supporting the general study conduct.</p>
        <p class="mb-4">The onboarding checklist is intended for study staff and helps to ensure that all relevant
          points about the intended usage of the app and procedure of the neotiv memory tests are covered during
          participant onboarding.</p>
        <p class="mb-6"> The FAQs and data security documents are provided for study staff. The FAQs can be referenced
          as needed, and the data security documents may be shared with participants during onboarding upon request.</p>

        <v-row no-gutters>
          <v-col cols="12" sm="6" class="support-box">
            <v-icon>mdi-list-status</v-icon>
            <h3 class="mb-4">Onboarding Checklist</h3>
            <ul class="support-list">
              <li class="d-flex flex-row align-items-center justify-space-between">
                <span class="d-flex flex-row"> <v-img
                  :src="require('@/assets/images/flags/gb.svg')" width="20px" class="mr-4"
                /> English</span>
                <v-btn
                  elevation="0">
                  <a href="/static/pdfs/manuals/neotivTrials_Onboarding_Checklist_EN.pdf"
                     target="_blank">
                    Download
                  </a>
                </v-btn>
              </li>
              <li class="d-flex flex-row align-items-center justify-space-between">
                <span class="d-flex flex-row"> <v-img
                  :src="require('@/assets/images/flags/de.svg')" width="20px" class="mr-4"
                /> German</span>
                <v-btn
                  elevation="0">
                  <a href="/static/pdfs/manuals/neotivTrials_Onboarding_Checklist_DE.pdf"
                     target="_blank">
                    Download
                  </a>
                </v-btn>
              </li>
            </ul>
          </v-col>
          <v-col cols="12" sm="6" class="support-box">
            <v-icon>mdi-message-question</v-icon>
            <h3 class="mb-4">FAQs</h3>
            <ul class="support-list">
              <li class="d-flex flex-row align-items-center justify-space-between">
                <span class="d-flex flex-row"> <v-img
                  :src="require('@/assets/images/flags/gb.svg')" width="20px" class="mr-4"
                /> English</span>
                <v-btn
                  elevation="0">
                  <a href="/static/pdfs/manuals/neotivTrials_FAQs_EN.pdf"
                     target="_blank">
                    Download
                  </a>
                </v-btn>
              </li>
              <li class="d-flex flex-row align-items-center justify-space-between">
                <span class="d-flex flex-row"> <v-img
                  :src="require('@/assets/images/flags/de.svg')" width="20px" class="mr-4"
                /> German</span>
                <v-btn
                  elevation="0">
                  <a href="/static/pdfs/manuals/neotivTrials_FAQs_DE.pdf"
                     target="_blank">
                    Download
                  </a>
                </v-btn>
              </li>
            </ul>
          </v-col>
          <v-col cols="12" sm="6" class="support-box">
            <v-icon>mdi-security</v-icon>
            <h3 class="mb-4">Data Protection Agreement</h3>
            <ul class="support-list">
              <li class="d-flex flex-row align-items-center justify-space-between">
                <span class="d-flex flex-row"> <v-img
                  :src="require('@/assets/images/flags/gb.svg')" width="20px" class="mr-4"
                /> English</span>
                <v-btn
                  elevation="0">
                  <a href="/static/pdfs/manuals/Data_privacy_neotivTrials_Jan_2026_EN.pdf"
                     target="_blank">
                    Download
                  </a>
                </v-btn>
              </li>
              <li class="d-flex flex-row align-items-center justify-space-between">
                <span class="d-flex flex-row"> <v-img
                  :src="require('@/assets/images/flags/de.svg')" width="20px" class="mr-4"
                /> German</span>
                <v-btn
                  elevation="0">
                  <a href="/static/pdfs/manuals/Datenschutzerklаеrung_neotivTrials_Jan_2026_DE.pdf"
                     target="_blank">
                    Download
                  </a>
                </v-btn>
              </li>
            </ul>
          </v-col>
          <v-col cols="12" sm="6" class="support-box">
            <v-icon>mdi-lock</v-icon>
            <h3 class="mb-4">Data Protection Concept</h3>
            <ul class="support-list">
              <li class="d-flex flex-row align-items-center justify-space-between">
                <span class="d-flex flex-row"> <v-img
                  :src="require('@/assets/images/flags/gb.svg')" width="20px" class="mr-4"
                /> English</span>
                <v-btn
                  elevation="0">
                  <a href="/static/pdfs/manuals/Data_Protection_Concept_neotivTrials_Jan_2026_EN.pdf"
                     target="_blank">
                    Download
                  </a>
                </v-btn>
              </li>
              <li class="d-flex flex-row align-items-center justify-space-between">
                <span class="d-flex flex-row"> <v-img
                  :src="require('@/assets/images/flags/de.svg')" width="20px" class="mr-4"
                /> German</span>
                <v-btn
                  elevation="0">
                  <a href="/static/pdfs/manuals/Datenschutzkonzept_neotivTrials_Jan_2026_DE.pdf"
                     target="_blank">
                    Download
                  </a>
                </v-btn>
              </li>
            </ul>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- Contact form -->
    <section class="contact bg-primary">
      <v-container class="py-12">
        <v-container>
          <h3 class="text-white text-center">
            Contact
          </h3>
          <p>
            If you have any further questions about neotiv, we will be happy to answer them. Please leave us a message
            here.
          </p>
        </v-container>
        <contact-form
          :formColor="'#57509C'"
          :formBtnColor="'#6DC1B9'"
          :newsletter="false"
        />
      </v-container>
    </section>
    <!-- Fullscreen Dialog with Video -->
    <v-dialog v-model="dialog" max-width="960" max-height="750" persistent @click:outside="dialog = false">
      <v-icon class="close-dialog-icon" @click="dialog = false">mdi-close</v-icon>

      <v-card class="pa-4">
        <video
          controls
          autoplay
          width="100%"
          height="700"
          :src="activeVideo"
        ></video>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ContactForm from "@/components/Form";
import {nextTick} from 'vue'

export default {
  components: {
    ContactForm
  },
  data() {
    return {
      activeVideo: '',
      dialog: false
    }
  },
  computed: {
    appStartVideo() {
      return require("@/assets/videos/app-start.mp4")
    },
    bugReportVideo() {
      return require("@/assets/videos/bug-report.mp4")
    },
    downloadAndroidVideo() {
      return require("@/assets/videos/download-android.mp4")
    },
    downloadAppleVideo() {
      return require("@/assets/videos/download-apple.mp4")
    },
    appStartVideoEn() {
      return require("@/assets/videos/en/app-start.mp4")
    },
    bugReportVideoEn() {
      return require("@/assets/videos/en/bug-report.mp4")
    },
    downloadAndroidVideoEn() {
      return require("@/assets/videos/en/download-android.mp4")
    },
    downloadAppleVideoEn() {
      return require("@/assets/videos/en/download-apple.mp4")
    },
    downloadTrialsEn() {
      return require("@/assets/videos/en/neotivPortal_FirstSteps_EN.mp4")
    }
  },
  methods: {
    scrollToSection(selector) {
      nextTick(() => {
        setTimeout(() => {
          const element = document.querySelector(selector)
          element.scrollIntoView({alignToTop: true, block: 'start', behavior: 'smooth'})
        }, 300)
      });
    },
    openVideo(videoSrc) {
      this.activeVideo = videoSrc
      this.dialog = true
    }
  }
};
</script>

<style scoped>

video {
  background-color: var(--v-videoBackgroundColor-base);
  border: 1px solid var(--v-videoBackgroundColor-base);
}

.hero-title {
  font-size: 48px;
  line-height: 1.25;
  font-weight: 600;
}

.hero-text {
  font-size: 24px;
  line-height: 1.25;
  color: #57509C;
}

@media only screen and (max-width: 600px) {
  .hero-title {
    font-size: 30px;
  }
}

.more-btn {
  top: -80px;
  font-size: 18px !important;
}

h1 {
  font-size: 38px;
}

ul {
  line-height: 1.75em;
}

body {
  font-family: 'Source Sans', sans-serif;
}

.video-wrapper {
  position: relative;
  width: 100%;
  height: 400px;
  cursor: pointer;
  overflow: hidden;
}

.inline-video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  pointer-events: none; /* Prevent native controls from triggering */
}

.trials-list li {
  list-style-type: none;
  padding: 20px;
  border-bottom: 1px solid #DDDBEB;
  display: flex;
  justify-content: space-between;
}

.trials-list .v-btn a {
  text-decoration: none;
  font-size: 17px;
}

.support-list {
  width: 90%;
}

.support-list li {
  list-style-type: none;
  border-bottom: 1px solid #DDDBEB;
  padding: 20px;
}

.support-list a {
  text-decoration: none;
  color: #000000;
  display: block;
  font-size: 16px;
}


.support-list li:hover a {
  transition: all 0.3s ease;
  color: #57509C;
}

.video-list > [class*=v-col-] {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: end;
}

.support-box {
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-bottom: 100px;
}

.support-box > [class*=mdi-] {
  font-size: 56px;
  color: #57509C;
  margin-bottom: 1rem;
}

.app-icon {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  position: relative;
}

.app-icon::after {
  content: "";
  display: inline-block;
  background-size: contain;
  background-repeat: no-repeat;

}

.app-icon.google::after {
  background-image: url('@/assets/images/google-play-store.svg');
  width: 20px;
  height: 20px;

}

.app-icon.apple::after {
  background-image: url('@/assets/images/app-store.svg');
  width: 25px;
  height: 25px;
}

.close-dialog-icon {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 99;
  cursor: pointer;
}

.anchor-section {
  scroll-margin-top: 90px;
}

@media only screen and (max-width: 600px) {
  .support-list li:last-child {
    margin-bottom: 2rem;
  }

  .support-box {
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-bottom: 40px;
  }
}
</style>
